import { useLocation } from "react-router-dom";
import { HeroSectionMinimal } from "@/components/hero-section-minimal";
import { ServicesSection } from "@/components/services-section";
import { CertificationsPartnershipsSection } from "@/components/certifications-partnerships-section";
import { CrossIndustrySolutionsSection } from "@/components/cross-industry-solutions-section";
import { AboutPreviewSection } from "@/components/about-preview-section";
import { NewsSection } from "@/components/news-section";
import { HomepageContactSection } from "@/components/homepage-contact-section";
import { getLocaleFromPathname } from "@/lib/i18n";

const Index = () => {
  const location = useLocation();
  const locale = getLocaleFromPathname(location.pathname);

  return (
    <div>
      {/* Hero with video background */}
      <HeroSectionMinimal key={location.key} locale={locale} />
      
      {/* Section 1: Leistungen (3 Kacheln) */}
      <ServicesSection locale={locale} />
      
      {/* Section 2: Branchen (6 Icons) */}
      <CrossIndustrySolutionsSection locale={locale} />
      
      {/* Section 2.5: Über uns Preview */}
      <AboutPreviewSection locale={locale} />
      
      {/* Section 3: Zertifizierungen & Partnerschaften (Vertrauenselement) */}
      <CertificationsPartnershipsSection locale={locale} />
      
      {/* Section 4: Aktuelle Meldungen */}
      <NewsSection locale={locale} />
      
      {/* Section 5: Kontakt */}
      <HomepageContactSection locale={locale} />
    </div>
  );
};

export default Index;
